import React from 'react';
import { Link } from 'react-router-dom';
import { FiPhone, FiMail, FiMapPin, FiFacebook, FiInstagram, FiTwitter, FiYoutube } from 'react-icons/fi';
import Logo from './Logo';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <div className="footer-logo">
                <Logo size={36} showText={true} textColor="white" />
              </div>
              <p className="footer-tagline">"An Offbeat Travel Agency"</p>
              <p className="footer-desc">
                Specializing in offbeat and unexplored destinations across India and beyond. We craft personalized travel experiences that go beyond the ordinary.
              </p>
              <div className="footer-socials">
                <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook"><FiFacebook /></a>
                <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram"><FiInstagram /></a>
                <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter"><FiTwitter /></a>
                <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube"><FiYoutube /></a>
              </div>
            </div>

            <div className="footer-col">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/trips">Backpacking</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Upcoming Trips</h4>
              <ul>
                <li><Link to="/trips">Ladakh Adventure</Link></li>
                <li><Link to="/trips">Kashmir Valley</Link></li>
                <li><Link to="/trips">Meghalaya Exploration</Link></li>
                <li><Link to="/trips">Kerala Backwaters</Link></li>
                <li><Link to="/trips">Spiti Valley Trek</Link></li>
                <li><Link to="/trips">Sri Lanka Tour</Link></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Contact Info</h4>
              <div className="contact-item">
                <FiPhone />
                <div>
                  <a href="tel:+918109849232">+91 81098 49232</a>
                  <a href="tel:+919425122751">+91 94251 22751</a>
                </div>
              </div>
              <div className="contact-item">
                <FiMail />
                <a href="mailto:hello@theunexploredroutes.com">hello@theunexploredroutes.com</a>
              </div>
              <div className="contact-item">
                <FiMapPin />
                <span>58/2, Ashok Niwas, Daulat Gang, Gwalior, MP - 474001</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>© {new Date().getFullYear()} The Unexplored Routes. All rights reserved.</p>
          <div className="footer-bottom-links">
            <span>Privacy Policy</span>
            <span>Terms & Conditions</span>
            <span>Refund Policy</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
